var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    _vm._l(_vm.downloads, function (download, index) {
      return _c("div", { staticClass: "col-12 col-md-6" }, [
        _c(
          "div",
          {
            class:
              "global-download " +
              (download.src
                ? "global-download--with-image"
                : "global-download--with-icon"),
          },
          [
            download.src
              ? [
                  _c(
                    "a",
                    {
                      staticClass: "global-download--image",
                      attrs: {
                        href: download.href,
                        target: "_blank",
                        "data-dlcat": _vm.trackingCategory(download),
                        "data-dlid": _vm.trackingId(download),
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: download.src,
                          width: "112",
                          alt: download.title,
                        },
                      }),
                    ]
                  ),
                ]
              : [
                  _c("a", {
                    staticClass:
                      "global-download--icon button button--ghost button--icon icon--before icon--download",
                    attrs: {
                      href: download.href,
                      target: "_blank",
                      "data-dlcat": _vm.trackingCategory(download),
                      "data-dlid": _vm.trackingId(download),
                    },
                  }),
                ],
            _vm._v(" "),
            _c("div", { staticClass: "global-download--properties" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: download.href,
                    target: "_blank",
                    "data-dlcat": _vm.trackingCategory(download),
                    "data-dlid": _vm.trackingId(download),
                  },
                },
                [
                  _c("p", { staticClass: "global-download--title" }, [
                    _c("b", [_vm._v(_vm._s(download.title))]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "global-download--file" }, [
                    _c("span", { staticClass: "global-download--file-type" }, [
                      _vm._v(_vm._s(download.ext)),
                    ]),
                    _vm._v(" (" + _vm._s(download.size) + ")"),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }